var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',{staticClass:"year-header"},[_c('IxRes',{attrs:{"context":{year: _vm.year - 1}}},[_vm._v("\n    frs.dlgCertIntegration.modals.harvestYearHelp.diagram.labels.harvestYear\n  ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }